"use strict";
//const aStar = require('a-star')
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPath = void 0;
var astar2_sidecar_1 = require("./astar2-sidecar");
// export interface IPathOptions<T> {
//   start: T
//   isEnd: (node: T) => boolean
//   neighbor: (node: T) => T[]
//   distance: (a: T, b: T) => number
//   heuristic: (node: T) => number
//   hash?: (node: T) => string
//   timeout?: number
// }
// export interface IPathResult<T> {
//   status: 'success' | 'noPath' | 'timeout'
//   path: T[]
// }
function findPath(options) {
    // let pathResult = aStar(options)
    // let pathResult = aStar_typescript(options) as any
    var pathResult = astar2_sidecar_1.astar2.findPath(options);
    // console.log(pathResult)
    return pathResult;
}
exports.findPath = findPath;
